// extracted by mini-css-extract-plugin
export default {"draw":"DrawSVG__draw"};